export const loadDateFnsLocale: (localeCode: string) => Promise<Locale> = async localeCode => {
  const localeModule = await import(`date-fns/locale/${localeCode}`);
  return localeModule.default;
};
